import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterArray',
  pure: false,
  standalone: false,
})
export class FitlerArrayPipe implements PipeTransform {
  transform(items: any[], callback: (items: any[]) => any[]): any[] {
    if (!items || !callback) {
      return items;
    }
    return callback(items);
  }
}
